import './DataGroupView.module'
import dataGroupPage from './DataGroupPage.component'
import StoreService from '../../../common/redux/store.service'

export default angular
  .module('components.dataGroupPage', ['components.tb.dataGroup'])
  .component('dataGroupPage', dataGroupPage)
  .service('StoreService', StoreService)
  .config($stateProvider => {
    $stateProvider.state('dataGroup', {
      parent: 'app',
      url: '^/data-group',
      component: 'dataGroupPage',
      reloadOnSearch: false
    })
  })
  .name
